export default __webpack_public_path__ + "static/media/lawyer.4650ee52.png";